<template>
  <f7-link
    v-if="canManage"
    icon-ios="f7:ellipsis"
    icon-md="material:more_horiz"
    class="fcm-btn"
    :aria-label="$t('common.edit')"
    @click.stop="openMenu"
  >
    <!-- <f7-icon f7="ellipsis" size="16" /> -->
  </f7-link>
</template>

<script setup>
import { f7 } from "framework7-vue";
import i18n from "../../js/i18n.js";

const props = defineProps({
  canManage: { type: Boolean, default: false },
  pinned: { type: Boolean, default: false },
});

const emit = defineEmits(["edit", "delete", "pin"]);

let actions = null;

function openMenu() {
  actions = f7.actions.create({
    convertToPopover: true,
    closeByOutsideClick: true,
    closeOnEscape: true,
    buttons: [
      [
        {
          text: props.pinned
            ? i18n.global.t("feed.unpin")
            : i18n.global.t("feed.pin"),
          icon: `<i class="f7-icons size-20">${props.pinned ? "xmark_circle" : "pin"}</i>`,
          onClick: () => emit("pin", !props.pinned),
        },
        {
          text: i18n.global.t("common.edit"),
          icon: '<i class="f7-icons size-20">pencil</i>',
          onClick: () => emit("edit"),
        },
        {
          text: i18n.global.t("common.delete"),
          color: "red",
          icon: '<i class="f7-icons size-20">trash</i>',
          onClick: () => emit("delete"),
        },
      ],
      [{ text: i18n.global.t("common.cancel"), color: "gray" }],
    ],
  });
  actions.open();
}
</script>

<style scoped>
.fcm-btn {
  border: none;
  background: none;
  color: var(--f7-on-surface-variant, #8e8e93);
  padding: 2px 4px;
  border-radius: 50%;
  cursor: pointer;
  flex-shrink: 0;
  line-height: 0;
}
</style>
